import { render, staticRenderFns } from "./resultingModal.vue?vue&type=template&id=e0f8063c&"
import script from "./resultingModal.vue?vue&type=script&lang=js&"
export * from "./resultingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports